<template>
  <div>
    <!-- Загрузка -->
    <div v-if="isLoading" style="display:flex; justify-content:center; padding:60px;">
      <q-spinner color="primary" size="3em" />
    </div>

    <!-- Ошибка -->
    <div v-else-if="error" style="padding:40px; text-align:center; color:#d32f2f;">
      <q-icon name="error_outline" size="48px" />
      <p style="margin-top:16px;">{{ error }}</p>
    </div>

    <!-- Контент -->
    <div v-else-if="projectData">
      <!-- Шапка -->
      <div style="padding: 12px 16px 0; font-size:18px; font-weight:700;">
        Смета — Проект #{{ projectId }}
        <span style="font-size:14px; font-weight:400; color:#666; margin-left:10px;">
          ({{ projectData.resident_name }}, {{ projectData.project_type_name }})
        </span>
      </div>

      <ProjectSmetaHub
        :project-id="projectId"
        :resident-id="projectData.resident_id || null"
        :project-type-id="projectData.project_type_id || null"
        :initial-tab="$route.query.tab || 'smeta_new'"
      />
    </div>
  </div>
</template>

<script>
import { getProjectsById } from './services';
import ProjectSmetaHub from './ProjectSmetaHub.vue';

export default {
  name: 'ProjectSmetaHubPage',
  components: { ProjectSmetaHub },
  props: {
    project_id: { type: [String, Number], default: null },
  },
  data() {
    return {
      projectData: null,
      isLoading: false,
      error: null,
    };
  },
  computed: {
    projectId() {
      return Number(this.$route.params.project_id || this.project_id);
    },
  },
  methods: {
    async loadProject() {
      if (!this.projectId) { this.error = 'Не указан ID проекта'; return; }
      this.isLoading = true;
      this.error = null;
      try {
        const res = await getProjectsById(this.projectId);
        const raw = Array.isArray(res) ? res[0] : res;
        this.projectData = raw || {
          resident_id: null,
          project_type_id: null,
          resident_name: '—',
          project_type_name: '—',
        };
      } catch (e) {
        this.projectData = {
          resident_id: null,
          project_type_id: null,
          resident_name: '—',
          project_type_name: '—',
        };
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.loadProject();
  },
  watch: {
    projectId(val) {
      if (val) this.loadProject();
    },
  },
};
</script>
